import React from 'react';
import { useTranslation } from 'react-i18next';

type InitializationStatusProps = {
  isInitializing: boolean;
  initializationAttempts: number;
  message: string;
};

function InitializationStatus({
  isInitializing,
  initializationAttempts,
  message,
}: InitializationStatusProps) {
  const { t } = useTranslation();
  if (!isInitializing) return null;

  return (
    <div className="mt-4 rounded-md border border-blue-200 bg-blue-50 p-3">
      <div className="flex items-center">
        <div className="mr-2 size-4 animate-spin rounded-full border-2 border-blue-600 border-t-transparent"></div>
        <div>
          <p className="text-sm text-blue-600">{message}</p>
          {initializationAttempts > 1 && (
            <p className="text-xs text-blue-500">
              {t('documentPersonal.initializationAttempts', `Attempt ${initializationAttempts}`)}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default InitializationStatus;
